import './totals.css';

type Props = {
  Title: string;
  Data: number;
  showCurrency?: boolean;
  currencySymbol?: string;
};

const Totals = ({ Title, Data, showCurrency = false, currencySymbol = '' }: Props) => {
  return (
    <div className="contentTotals">
      <div className="itemTotals">
        <span>{Title}</span>
        <span>
          {showCurrency
            ? `${currencySymbol}${(Number.isFinite(Data) ? Data : 0).toFixed(2)}`
            : Data}
        </span>
      </div>
    </div>
  );
};

export default Totals;
